export const ECOM2_FLAG = 'feature.ecom2';

export type EcomVersion = 'ecom1' | 'ecom2';

export const ecomVersionLabel = (isEcom2: boolean): EcomVersion => (isEcom2 ? 'ecom2' : 'ecom1');
